"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = PendingCashPayment;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _readOnlyError2 = _interopRequireDefault(require("@babel/runtime/helpers/readOnlyError"));
var _react = _interopRequireDefault(require("react"));
var _reactNative = require("react-native");
var _styles = require("@sart/styles");
var _client = _interopRequireDefault(require("@sart/client"));
var _content = require("@sart/content");
var _Text = _interopRequireDefault(require("./Text"));
var _Label = _interopRequireDefault(require("./Label"));
var _Space = _interopRequireDefault(require("./Space"));
var _Anchor = _interopRequireDefault(require("./Anchor"));
var _Button = _interopRequireDefault(require("./Button"));
var _moment = _interopRequireDefault(require("moment"));
require("moment/locale/es-us");
require("moment/locale/en-gb");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } // import moment from 'moment'
// import Price from './Price'
// import StoredPaymentMethod from './StoredPaymentMethod'
function PendingCashPayment(props) {
  var product = props.product,
    onEditProduct = props.onEditProduct,
    onEditPayment = props.onEditPayment,
    onCancelProduct = props.onCancelProduct,
    price = props.price,
    expiryDate = props.expiryDate,
    creationDate = props.creationDate,
    daysToExpire = props.daysToExpire,
    titleStyle = props.titleStyle,
    priceStyle = props.priceStyle,
    cashContainer = props.cashContainer,
    descriptionStyle = props.descriptionStyle,
    descriptionContentStyle = props.descriptionContentStyle,
    dateStyle = props.dateStyle,
    buttonTitleStyle = props.buttonTitleStyle,
    onPress = props.onPress,
    buttonStyle = props.buttonStyle;
  var content = (0, _content.useContent)();
  var formatDate = function formatDate(date, language) {
    if (date) {
      var formatted = (0, _moment["default"])(date).locale(language).format('ddd D MMM');
      var elements = formatted.split('.').join('').split(' ');
      elements[0] = elements[0][0].toUpperCase() + elements[0].slice(1);
      elements[2] = elements[2][0].toUpperCase() + elements[2].slice(1);
      return elements.join(' ');
    }
    return null;
  };
  function displayExpiryDate() {
    if (expiryDate) {
      return expiryDate.toString();
    } else if (creationDate && daysToExpire >= 0) {
      if (creationDate instanceof Date) {
        var toReturn = new Date(creationDate);
        toReturn.setDate(creationDate.getDate() + daysToExpire);
        return toReturn;
      } else {
        new Date(), (0, _readOnlyError2["default"])("creationDate");
        creationDate.setDate(creationDate.getDate() + daysToExpire);
        return creationDate.toDateString();
      }
    } else {
      return 'N/A';
    }
  }
  var language;
  if (_client["default"].cache.language === 'en') {
    language = 'en-gb';
  } else if (_client["default"].cache.language === 'es') {
    language = 'es-us';
  }
  ;
  return /*#__PURE__*/_react["default"].createElement(_reactNative.View, {
    style: cashContainer ? cashContainer : styles.container
  }, /*#__PURE__*/_react["default"].createElement(_Label["default"], {
    style: titleStyle ? titleStyle : styles.label
  }, content.dashboard.pendingPayment), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    style: priceStyle ? priceStyle : styles.name
  }, price), /*#__PURE__*/_react["default"].createElement(_reactNative.View, {
    style: styles.row
  }, /*#__PURE__*/_react["default"].createElement(_reactNative.View, {
    style: styles.column
  }, /*#__PURE__*/_react["default"].createElement(_Label["default"], {
    style: descriptionStyle ? descriptionStyle : styles.label
  }, content.dashboard.description), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    style: descriptionContentStyle ? descriptionContentStyle : styles.text
  }, content.dashboard.cashPurchase)), /*#__PURE__*/_react["default"].createElement(_reactNative.View, {
    style: styles.column
  }, /*#__PURE__*/_react["default"].createElement(_Label["default"], {
    style: descriptionStyle ? descriptionStyle : styles.label
  }, content.dashboard.payUntil), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    style: dateStyle ? dateStyle : styles.text
  }, formatDate(displayExpiryDate(), language)))), /*#__PURE__*/_react["default"].createElement(_Space["default"], {
    height: 12
  }), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    title: content.dashboard.buttonTitle,
    onPress: onPress,
    titleStyle: buttonTitleStyle,
    style: buttonStyle
  }), /*#__PURE__*/_react["default"].createElement(_Space["default"], {
    height: 12
  }));
}
var styles = _reactNative.StyleSheet.create({
  container: _objectSpread({
    padding: 24,
    backgroundColor: _styles.backgroundColors.clear,
    borderRadius: _styles.radius.medium,
    elevation: 8
  }, _styles.shadows.shadowByElevation(8)),
  name: {
    fontSize: 32,
    lineHeight: 48,
    fontWeight: '700',
    color: _styles.colors.feature
  },
  row: {
    flexDirection: 'row'
  },
  column: {
    flex: 1,
    flexDirection: 'column'
  },
  label: {
    fontSize: 14,
    lineHeight: 24
  },
  text: {
    fontSize: 14,
    lineHeight: 24,
    color: _styles.colors.feature
  },
  cancel: {
    color: _styles.colors.trivial,
    textAlign: 'center'
  }
});